import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PathologyService } from 'src/app/pathology.service';
import { PrintService } from 'src/app/print.service';

@Component({
    selector: 'app-endoscopy-print',
    templateUrl: './endoscopy-print.component.html',
    styleUrls: ['./endoscopy-print.component.scss'],
    standalone: false
})
export class EndoscopyPrintComponent implements OnInit {
  examID: number;
  PID: number;
  now: Date;

  Direction = 'rtl';
  typeOfPrint = 'simple';
  loaded = false;
  hasImages = false;
  imPerPage = 2;
  altHeader: SafeHtml;
  showHeader = true;
  labReports: any[] = [];
  reportsLoaded = false;

  constructor(
    public pathologyS: PathologyService,
    private route: ActivatedRoute,
    public print: PrintService,
    public translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {
    this.now = new Date();
  }

  ngOnInit() {
    this.translate.use(this.route.snapshot.params.LANG);
    if (this.route.snapshot.params.LANG !== 'he-IL' && this.route.snapshot.params.LANG !== 'ar-JO')
      this.Direction = 'ltr';
    this.typeOfPrint = this.route.snapshot.params.style;
    this.loaded = true;
    const code = this.route.snapshot.params['code'];
    this.examID = this.route.snapshot.params.examid;
    this.PID = this.route.snapshot.params.PID;
    if (this.route.snapshot.params['images'] === 'y') {
      this.hasImages = true;
      this.imPerPage = this.route.snapshot.params['perpage'];
    }
    if (this.route.snapshot.params['perpage'] === 'All') {
      this.hasImages = true;
      this.imPerPage = 2;
      this.print.allImages = true;
    } else {
      this.print.allImages = false;
    }
    if (this.route.snapshot.params.hasOwnProperty('showheader'))
      this.showHeader = this.route.snapshot.params['showheader'] === 'y';

    this.print.loadExam(this.examID, this.PID, this.hasImages, code);
    this.print.loadMsg.subscribe(() => {
      if (this.print.env['htmlheader']) {
        this.altHeader = this.sanitizer.bypassSecurityTrustHtml(this.print.env['htmlheader']);
      }
      this.loadLabReports();
    });
  }

  get subExamType(): string {
    return this.print.exam?.SubExamType || '';
  }

  get isGastro(): boolean {
    return this.subExamType === 'Gastro' || this.subExamType === 'Both';
  }

  get isColono(): boolean {
    return this.subExamType === 'Colonoscopy' || this.subExamType === 'Both' || this.subExamType === 'HRA';
  }

  get isOther(): boolean {
    return this.subExamType === 'Other';
  }

  // segment radios: 0 = Normal, 1 = Abnormal, -1 / empty = not marked
  isMarked(value: any): boolean {
    return value !== '' && value !== null && value !== undefined && (value == 0 || value == 1);
  }

  loadLabReports() {
    if (!this.reportsLoaded) {
      this.reportsLoaded = true;
      this.pathologyS.getLabReports().subscribe((data: any[]) => {
        for (const item of data) {
          if (item.ExamID == this.examID && item.Analyzed) {
            this.labReports.push(item);
          }
        }
      });
    }
  }
}
